'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

export const chrome_href = 'https://chromewebstore.google.com/detail/'
    +'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio';
export const firefox_href = 'https://addons.mozilla.org/en-US/firefox/addon/'
    +'hola-free-vpn-proxy-unblocker/';
export const opera_href = 'https://addons.opera.com/en/extensions/details/'
    +'hola-better-internet/';
export const edge_href = 'https://microsoftedge.microsoft.com/addons/detail/'
    +'eibinhpjpbkmjeohlclnebmkhdfehpbf';
export const apple_href = 'https://apps.apple.com/us/app/'
    +'hola-vpn/id1553473179?platform=iphone';
export const huawei_href = 'https://appgallery.huawei.com/#/app/C102688195';
export const samsung_href =
    'https://galaxystore.samsung.com/detail/org.hola.samsung';
export const firetv_href =
    'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/'
    +'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8';
export const appletv_href =
    'https://apps.apple.com/us/app/hola-vpn/id1553473179?'
    +'platform=appleTV';
